import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CampaignFrequencyReport, CampaignFrequencyReportService } from '../services/campaign-frequency-report.service';

@Component({
  selector: 'statistics-dashboard',
  templateUrl: './statistics-dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StatisticsDashboard implements OnInit {
  frequencyReports: CampaignFrequencyReport[];

  constructor(
    private campaignFrequencyReportService: CampaignFrequencyReportService,
    private changeDetection: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.campaignFrequencyReportService.getAll().then((reports) => {
      this.frequencyReports = reports;
      this.changeDetection.markForCheck();
    });
  }
}
